<script>
    /**
     * @typedef {Object} Props
     * @property {boolean} [long_page_footer]
     * @property {import('svelte').Snippet} [children]
     */

    /** @type {Props} */
    let {
        long_page_footer = true,
        children
    } = $props();

</script>

<div class=page-wrapper>
    {@render children?.()}
</div>
{#if long_page_footer}
<footer class="footer" style="height:30em;">
    <div class="content">
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
        <p></p>
    </div>
</footer>
{/if}

<style>

.page-wrapper {
    margin-left: 1rem;
    margin-right: 1rem;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0.5rem;
}    

</style>

